import { nanoid } from "nanoid";
import React, { useEffect, useState } from "react";
import { Carousel } from "react-responsive-carousel";
import "react-responsive-carousel/lib/styles/carousel.min.css";
import { api, baseURL, customerReqConfig } from "../../src/include/api";

const BannerTwo = () => {
  const [fetchLoading, setFetchLoading] = useState(false);
  const [slideList, setSlideList] = useState([]);

  const getSlides = () => {
    setFetchLoading(true);
    api
      .get("/slide_show/", customerReqConfig)
      .then((response) => {
        if (response.status === 200) {
          console.log("slide", response);

          setSlideList(response.data.data);
        }
      })
      .catch((error) => {
        console.error("Error fetching slides", error);
      })
      .finally(() => {
        setFetchLoading(false);
      });
  };

  useEffect(() => {
    getSlides();
  }, []);

  // Filter slides for each container
  const MainSlides = slideList?.filter(
    (slide) => slide.status === "active" && slide.type === "main",
  );

  return (
    <div className="banner-two mb-4">
      <div className="container container-lg">
        <div className="banner-two-wrapper d-flex align-items-start">
          <div
            className="banner-item-two-wrapper home-slide-frame home-slide-ratio rounded-24 overflow-hidden arrow-center flex-grow-1 ms-0 ps-0 mb-0 pb-0"
            style={{ "--slide-ratio": "1680 / 499" }}
          >
            {fetchLoading ? (
              <div className="w-100 bg-light" style={{ aspectRatio: "1024 / 323" }} />
            ) : (
              <Carousel
                autoPlay
                className="banner-img"
                infiniteLoop
                interval={3000}
                preventMovementUntilSwipeScrollTolerance
                showThumbs={false}
                transitionTime={100}
                showStatus={false}
                showIndicators={false}
              >
                {MainSlides?.map((slide) => (
                  <CarouselItem slide={slide} key={nanoid()} />
                ))}
              </Carousel>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

const CarouselItem = ({ slide }) => {
  const handleClick = () => {
    if (slide.linkUrl) {
      window.open(slide.linkUrl, "_blank");
    }
  };

  return (
    <div style={{ cursor: slide.linkUrl ? "pointer" : "default", height: "100%" }} onClick={handleClick}>
      <img
        src={slide.imageUrl ? `${baseURL}/${slide.imageUrl}` : ""}
        alt=""
        className="fit-cover"
      />
    </div>
  );
};

export default BannerTwo;
